import { Outlet } from "react-router";
import LoadingIndicator from "~/components/shared/LoadingIndicator";

export default function Auth() {
  return (
    <>
      <LoadingIndicator />
      <Outlet />;
    </>
  );
}
